var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPillow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 3C7.8 4.2 16.2 4.2 18 3C19.66 3 21 4.34 21 6C19.8 7.8 19.8 16.2 21 18C21 19.66 19.66 21 18 21C16.2 19.8 7.8 19.8 6 21C4.34 21 3 19.66 3 18C4.2 16.2 4.2 7.8 3 6C3 4.34 4.34 3 6 3M8 7C8.65 9.75 8.65 14.25 8 17C10.45 16.35 13.55 16.35 16 17C15.35 14.25 15.35 9.75 16 7C13.55 7.65 10.45 7.65 8 7Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillow);
export default __webpack_public_path__ + "static/media/pillow.e805e3e30e77ed9027f6af986e9c9497.svg";
export { ForwardRef as ReactComponent };